<template>
  <v-app class="app-tabela">
    <v-card class="tabela">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          class="input-bottom"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        @pagination="getPagination"
        :page="currentPage"
        :footer-props="{
          itemsPerPageText: '',
          'items-per-page-options': [10],
          'disable-items-per-page': true,
        }"
        :loading="loading"
        loading-text="Carregando, Por favor espere"
        :headers="headers"
        :items="indexedItems"
        :search="search"
        item-key="index"
        class="elevation-1"
        :single-expand="true"
        :expanded.sync="expanded"
        show-expand
        @item-expanded="onItemExpanded"
      >
        <template v-slot:item.dt_visita="{ item }">
          <td>
            {{ item.dt_visita != null ? formatDate(item.dt_visita) : '' }}
          </td>
        </template>

        <template v-slot:item.motivo_acomp="{ item }">
          <td>
            {{
              item.motivo_acomp != null
                ? JSON.parse(item.motivo_acomp).join(', ')
                : ''
            }}
          </td>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td colspan="9">
            <table class="table table-interna table-interna-acompanhamento">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>CFCP</th>
                  <th>CPF</th>
                  <th>CNS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ item.id }}</td>
                  <td>{{ item.cfcp }}</td>
                  <td>{{ item.cpf }}</td>
                  <td>{{ item.cns }}</td>
                </tr>
              </tbody>
            </table>

            <b-alert
              v-if="item.duplicadoInfo"
              variant="danger"
              show
              class="mt-2"
            >
              Registro duplicado. Tem outro atendimento na data
              {{ item.duplicadoInfo.data }}
              com esse mesmo Identificador (Id {{ item.duplicadoInfo.id }}).
              Recomenda-se realizar auditoria no Banco de Dados.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'gestante' &&
                !tipoContem(item, 'Gestante')
              "
              variant="danger"
              show
              class="mt-2"
            >
              Não marcado "Gestante" no motivo da visita neste atendimento.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'puerpera' &&
                !tipoContem(item, 'Puérpera')
              "
              variant="danger"
              show
              class="mt-2"
            >
              Não marcado "Puérpera" no motivo da visita neste atendimento.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'crianca' &&
                !tipoContem(item, 'Criança')
              "
              variant="danger"
              show
              class="mt-2"
            >
              Não marcado "Criança" no motivo da visita neste atendimento.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'diabetes' &&
                !tipoContem(item, 'Diabetes')
              "
              variant="danger"
              show
              class="mt-2"
            >
              Não marcado "Diabetes" no motivo da visita neste atendimento.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'hipertensao' &&
                !tipoContem(item, 'Hipertensão')
              "
              variant="danger"
              show
              class="mt-2"
            >
              Não marcado "Hipertensão" no motivo da visita neste atendimento.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'idosa' &&
                !tipoContem(item, 'Pessoa idosa')
              "
              variant="danger"
              show
              class="mt-2"
            >
              Não marcado "Pessoa idosa" no motivo da visita neste atendimento.
            </b-alert>
          </td>
        </template>

        <template v-slot:[`footer.page-text`]="items">
          <div class="info-table-item tabela-esus-pec">
            <FonteSincronizadorC />
          </div>
          <span class="paginacao"
            >{{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }} registros</span
          >
        </template>

        <template v-slot:no-data>
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>
        <template v-slot:no-results style="padding: 0px">
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'Visitas',
  props: {
    cidadao: {
      type: Object,
      default: () => null,
    },
    filtroAtendimento: {
      type: Object,
      default: () => ({ filtro: null, operador: '>=', data: '' }),
    },
    cnsList: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [utils],
  data() {
    return {
      expanded: [],
      headers: [
        {
          text: 'DATA',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_visita',
        },
        {
          text: 'VISITANTE',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'no_profissional',
        },
        {
          text: 'PESO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'nu_peso',
        },
        {
          text: 'ALTURA',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'nu_altura',
        },
        {
          text: 'PA',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'pa',
        },
        {
          text: 'DESFECHO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'desfecho',
        },
        {
          text: 'MOTIVO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'motivo_acomp',
        },
        { text: '', value: 'data-table-expand' },
      ],
      cadastros: [],
      currentPage: 1,
      search: '',
      loading: false,
    }
  },
  mounted() {
    this.buscarDados()
  },
  computed: {
    cadastrosFiltrados() {
      const { operador, data } = this.filtroAtendimento || {}

      // sem data ou sem operador: retorna tudo
      if (!data || !operador) return this.cadastros

      return this.cadastros.filter((item) => {
        const dataItem = item.dt_visita.split('/').reverse().join('-')
        return this._compareDates(dataItem, data, operador)
      })
    },

    indexedItems() {
      return this.cadastrosFiltrados.map((item, index) => ({
        index,
        ...item,
      }))
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Compara duas datas no formato YYYYMMDD.
     * @param {String} aYmd Primeira data
     * @param {String} bYmd Segunda data
     * @param {String} op Operador de comparação
     * @returns {Boolean}
     */
    _compareDates(aYmd, bYmd, op) {
      if (!aYmd || !bYmd) return true
      switch (op) {
        case '>':
          return aYmd > bYmd
        case '<':
          return aYmd < bYmd
        case '>=':
          return aYmd >= bYmd
        case '<=':
          return aYmd <= bYmd
        case '=':
          return aYmd === bYmd
        default:
          return true
      }
    },

    /**
     * Busca os dados
     */
    async buscarDados() {
      try {
        this.loading = true

        const response = await this.$api.get(
          `/app/cidadao/${this.$store.state.cod_ibge}/${this.cidadao.nu_cpf}/${this.cidadao.nu_cns}/unificacoes`
        )
        if (response) {
          let cnsListUnificacoes = [
            ...new Set(
              response.data
                .map((i) => (i?.cns != null ? String(i.cns).trim() : null))
                .filter((cns) => cns !== null && cns !== '')
            ),
          ]
          if (cnsListUnificacoes.length == 0) {
            cnsListUnificacoes = [0]
          }

          let cnsListParam = cnsListUnificacoes.join(',')

          const response2 = await this.$api.get(
            `/app/acs-por-cidadao/${this.$store.state.cod_ibge}/${this.cidadao.nu_cpf}/${cnsListParam}/visitas`
          )
          if (response2) {
            this.cadastros = response2.data
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Verifica se o tipo do item contém o termo informado.
     * @param {Object} item Item da listagem
     * @param {String} termo Texto a ser buscado
     * @returns {Boolean}
     */
    tipoContem(item, termo) {
      if (!item.motivo_acomp) return false

      // Normaliza textos (remove acentos e baixa-case)
      const normalizar = (str) =>
        str
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()

      const termoNormalizado = normalizar(termo)

      let tipos = []
      try {
        tipos = JSON.parse(item.motivo_acomp)
      } catch (e) {
        return false
      }

      // Normaliza todos os itens e verifica se contém o termo
      return tipos
        .map((t) => normalizar(t))
        .some((t) => t.includes(termoNormalizado))
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} ctx Contexto do item expandido
     */
    onItemExpanded(ctx) {
      const item = ctx?.item

      if (!item) return

      const duplicados = this.indexedItems.filter((i) => i.id === item.id)
      if (duplicados.length >= 2) {
        this.$set(item, 'duplicadoInfo', {
          data: item.dt_atendimento ? this.formatDate(item.dt_atendimento) : '',
          id: item.id,
        })
      } else {
        this.$delete(item, 'duplicadoInfo')
      }
    },
  },
}
</script>

<style></style>
